import React, {useState} from 'react';
import style from "./index.module.css";
import {Button, Spin} from "antd";
import {DownloadOutlined} from '@ant-design/icons';
import {fileBaseUrl} from "../../utils";
import {Document, Page, pdfjs} from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';

/* pdfjs worker 配置 */
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const NoticeArticle = ({subpath, articleId}: { subpath: string, articleId: string }) => {
    const comFile = fileBaseUrl();
    const fileUrl = `${comFile}liangshan_article_${articleId}.pdf`;

    const [numPages, setNumPages] = useState<number>();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string>('');

    /* 标题映射 */
    const getTitle = () => {
        switch (subpath) {
            case 'c1': return '通知公告';
            case 'c2': return '行业动态';
            case 'c3': return '政策法规';
            case 'c4': return '暂停撤销公告';
            default: return '';
        }
    };

    /* PDF 加载成功回调 */
    const onDocumentLoadSuccess = ({numPages: total}: { numPages: number }) => {
        setNumPages(total);
        setLoading(false);
    };

    const onDocumentLoadError = () => {
        setError('PDF 加载失败');
        setLoading(false);
    };

    /* 下载文件 */
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div>
            <div className={style.articleTitle}>
                {getTitle()}
            </div>

            <div className={style.content}>
                <div className={style.pdfContainer}>
                    <Spin spinning={loading} tip="正在加载文档...">
                        <Document
                            file={fileUrl}
                            onLoadSuccess={onDocumentLoadSuccess}
                            onLoadError={onDocumentLoadError}
                            loading={null}
                        >
                            {Array.from({length: numPages || 0}, (_, i) => (
                                <div key={`page_${i + 1}`} className={style.pdfPage}>
                                    <Page
                                        pageNumber={i + 1}
                                        width={780}
                                        renderTextLayer={false}
                                        renderAnnotationLayer={true}
                                    />
                                </div>
                            ))}
                        </Document>
                    </Spin>
                    {error && (
                        <div className={style.errorTip}>
                            <div>{error}</div>
                            <Button type="link" icon={<DownloadOutlined/>} onClick={handleDownload}>
                                下载文件查看
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NoticeArticle;
